import styled from 'styled-components'

export const EditorContainer = styled.div`
  .quill {
    border: 1px solid #999999;
    border-radius: 15px;
    overflow: hidden;

    .ql-toolbar {
      background-color: #000;

      /* background-color: #eeeeee; */
      border: 0;

      .ql-formats {
        /* background-color: red; */
        margin-right: 4px;
      }
    }
    .ql-container {
      min-height: 80px;
      border: 0;
    }
  }
`
